import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    MotifVerticalNavigation,
    MotifVerticalNavigationContent,
    MotifVerticalNavigationMenu,
    MotifVerticalNavigationMenuItem,
    MotifVerticalNavigationSubmenu,
    MotifVerticalNavigationFooter,
    MotifVerticalNavigationContextSwitcher,
    MotifIcon,
    MotifButton
} from '@ey-xd/motif-react';
import { actionIcSearch24px, actionIcTurnedInNot24px, hardwareIcPhonelink24px, socialIcPages24px, actionIcDescription24px, actionIcAssignment24px, socialIcPeople24px, actionIcSettings24px, socialIcPerson24px,  appIcWindow24px} from "@ey-xd/motif-react/assets/icons";
import './SideBar.scss';
import { Motif_Ey, Iconoir_Computer, Iconoir_Group } from '@ey-xd/motif-icon'
import ReportLibraryLogo from '../../assets/media/images/repository.png'
import ReportGeneratorLogo from '../../assets/media/images/vector.png'

const SideBar = ({ collapsed }: any) => {

    const location = useLocation();
    const navigate = useNavigate();

    const redirectSelectedRoute = (path: string) => {
        navigate(path);
    };

    return (
        <div className={`sideNavWrapper ${collapsed ? 'collapsedWidth': ''}`}>
            <MotifVerticalNavigation>
                <MotifVerticalNavigationContent>
                    <MotifVerticalNavigationMenu>
                        <MotifVerticalNavigationMenuItem
                            icon={<img src={ReportGeneratorLogo} alt="Report Generator" width={20} />}
                            label="Report Generator"
                            selected={location?.pathname.includes('/reportGenerator')}
                            onClick={() => redirectSelectedRoute('/reportGenerator')}
                        >
                            Report Generator
                        </MotifVerticalNavigationMenuItem>
                        <MotifVerticalNavigationMenuItem
                            icon={<img src={ReportLibraryLogo} alt="Report Library" width={20} />}
                            label="Report Library"
                            selected={location?.pathname.includes('/reportLibrary')}
                            onClick={() => redirectSelectedRoute('/reportLibrary')}
                        >
                            Report Library
                        </MotifVerticalNavigationMenuItem>
                        {/* <MotifVerticalNavigationMenuItem
                            icon={<MotifIcon src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTYgMTFjMS42NiAwIDIuOTktMS4zNCAyLjk5LTNTMTcuNjYgNSAxNiA1Yy0xLjY2IDAtMyAxLjM0LTMgM3MxLjM0IDMgMyAzem0tOCAwYzEuNjYgMCAyLjk5LTEuMzQgMi45OS0zUzkuNjYgNSA4IDVDNi4zNCA1IDUgNi4zNCA1IDhzMS4zNCAzIDMgM3ptMCAyYy0yLjMzIDAtNyAxLjE3LTcgMy41VjE5aDE0di0yLjVjMC0yLjMzLTQuNjctMy41LTctMy41em04IDBjLS4yOSAwLS42Mi4wMi0uOTcuMDUgMS4xNi44NCAxLjk3IDEuOTcgMS45NyAzLjQ1VjE5aDZ2LTIuNWMwLTIuMzMtNC42Ny0zLjUtNy0zLjV6Ii8+PC9zdmc+" />}
                            label="Clients"
                            selected={location?.pathname.includes('clients')}
                            onClick={() => redirectSelectedRoute('/clients')}
                        >
                            Clients
                        </MotifVerticalNavigationMenuItem> */}
                        <MotifVerticalNavigationMenuItem
                            icon={<MotifIcon src={hardwareIcPhonelink24px} />}
                            label="Applications"
                            selected={location?.pathname.includes('/applicationProfile')}
                            onClick={() => redirectSelectedRoute('/applicationProfile')}
                        >
                            Applications
                        </MotifVerticalNavigationMenuItem>

                        <MotifVerticalNavigationSubmenu
                            selected={location?.pathname.includes('/clients') || location?.pathname.includes('/userManagement')}
                            icons={{ title: <MotifIcon src={actionIcSettings24px} size="20" title="Settings"/> }}
                            role="tab"
                            title="Settings"
                        >
                            {/* <MotifVerticalNavigationMenuItem
                                label="Client Profile"
                                selected={location?.pathname.includes('/clients')}
                                onClick={() => redirectSelectedRoute('/clients')}
                            >
                                Client Profile
                            </MotifVerticalNavigationMenuItem> */}

                            <MotifVerticalNavigationMenuItem
                                label="User Management"
                                selected={location?.pathname.includes('/userManagement')}
                                onClick={() => redirectSelectedRoute('/userManagement')}
                            >
                                User Management
                            </MotifVerticalNavigationMenuItem>
                        </MotifVerticalNavigationSubmenu>
                    </MotifVerticalNavigationMenu>
                </MotifVerticalNavigationContent>
            </MotifVerticalNavigation>
        </div>
    )
}

export default SideBar;
